import { MarketplaceCardMedium } from 'marketplace-embed/js/components/MarketplaceCardMedium';
import { useUnifiedDetailsV3 } from 'marketplace-ui-common/hooks/useUnifiedDetailsV3';
import { getFormattedShortlinkUrl, navigateTo } from 'marketplace-ui-common/utils/DetailsPageUrls';
import { useUsageTracker } from 'marketplace-ui-tracking';
import { generatePath, useHistory } from 'quartz-routing/react-router';
import * as t from 'ts-schema';
import { Paths } from '../../constants/paths';
import { jsx as _jsx } from "react/jsx-runtime";
export function StorefrontListingCard({
  listing,
  collectionId,
  collectionSlug,
  context,
  pageNumber,
  queryType,
  resultCount,
  resultIndex,
  searchTerm,
  section,
  appContext
}) {
  const tracker = useUsageTracker();
  const history = useHistory();
  const product = listing.products[0];
  const isFeaturedAgent = product.agentType === 'OFF_PLATFORM';
  const isEmbedded = window.location.pathname.includes('/marketplace-embed/');
  const {
    unifiedDetailsData
  } = useUnifiedDetailsV3({
    appContext: appContext || 'public',
    slug: listing.slug,
    skip: appContext !== 'app' || !isFeaturedAgent || (listing === null || listing === void 0 ? void 0 : listing.slug) === undefined
  });
  const shouldRouteTo1PAgentLandingPage = (unifiedDetailsData === null || unifiedDetailsData === void 0 ? void 0 : unifiedDetailsData.installUrl) && isFeaturedAgent && appContext === 'app';
  const landingPageOverrideUrl = getFormattedShortlinkUrl(unifiedDetailsData === null || unifiedDetailsData === void 0 ? void 0 : unifiedDetailsData.installUrl);
  const pathTemplate = product.productType === 'SOLUTIONS_PARTNER_PROFILE' ? Paths.SOLUTIONS_PARTNERS_DETAILS : Paths.LISTING_DETAILS;
  const listingHref = generatePath(pathTemplate, {
    listingSlug: t.assert(t.string, listing.slug)
  });
  function onStorefrontCardClicked() {
    if (shouldRouteTo1PAgentLandingPage) {
      navigateTo(landingPageOverrideUrl, isEmbedded);
    } else {
      history.push(listingHref);
    }
  }
  return /*#__PURE__*/_jsx(MarketplaceCardMedium, {
    listing: listing,
    onClick: onStorefrontCardClicked,
    tracker: tracker,
    trackingProps: {
      collectionId,
      collectionSlug,
      pageNumber,
      queryType,
      resultCount,
      resultIndex,
      search: searchTerm,
      section,
      value: context === null || context === void 0 ? void 0 : context.value
    }
  });
}